export const CLEANUP_BOUNDS = { left: -1200, top: -1000, right: 1800, bottom: 1100 };

// Both worlds share the same perspective and drop target, including in the captured photo.
export function cleanupGround(bounds) {
  const floor = Math.max(1100, bounds.bottom + 100);
  const edgeLeft = Math.min(-1200, bounds.left - 100);
  const edgeRight = Math.max(1800, bounds.right + 100);
  const pathEnd = Math.max(580, bounds.bottom + 64);
  const leftDepth = pathEnd - 480;
  const rightDepth = pathEnd - 477;
  const leftFar = 86 - leftDepth * .5;
  const rightFar = 407 + rightDepth * 1.35;
  const leftContour = `M330 282C317 309 274 321 227 344C160 377 103 420 86 480C${86 - leftDepth * .12} ${480 + leftDepth * .33} ${86 - leftDepth * .35} ${480 + leftDepth * .67} ${leftFar} ${pathEnd}`;
  const rightContour = `M352 287C343 307 323 326 309 348C280 391 330 428 407 477C${407 + rightDepth * .5} ${477 + rightDepth * .33} ${407 + rightDepth * .95} ${477 + rightDepth * .67} ${rightFar} ${pathEnd}`;
  const path = `${leftContour}L${rightFar} ${pathEnd}C${407 + rightDepth * .95} ${477 + rightDepth * .67} ${407 + rightDepth * .5} ${477 + rightDepth * .33} 407 477C330 428 280 391 309 348C323 326 343 307 352 287Q343 278 330 282Z`;
  const pavers = [];
  for (let y = 520, row = 0; y < pathEnd; y += 40 + (y - 480) * .18, row += 1) {
    const halfWidth = 26 + (y - 480) * .055;
    const halfHeight = halfWidth * .42;
    for (let column = -1; column <= 1; column += 1) {
      const x = 270 + (y - 480) * .4 + column * halfWidth * 2.7 + (row % 2 ? halfWidth * .7 : 0);
      pavers.push(`M${x - halfWidth} ${y}L${x} ${y - halfHeight}L${x + halfWidth} ${y}L${x} ${y + halfHeight}Z`);
    }
  }
  return { floor, edgeLeft, edgeRight, path, leftContour, rightContour, pavers: pavers.join(' ') };
}
